import { AHText, Box, Circle, Inline } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { Header } from "../RoutineOccasion/RoutineDetail/Header";
import { IssueStatsTopTypes_IssueStats$key } from "./__generated__/IssueStatsTopTypes_IssueStats.graphql";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";

export function IssueStatsTopTypes(props: {
  issueStats: IssueStatsTopTypes_IssueStats$key;
}) {
  const intl_tokens = useIntlTokens();
  const data = useFragment(
    graphql`
      fragment IssueStatsTopTypes_IssueStats on IssueStats {
        topIssueTitles {
          title
          count
        }
      }
    `,
    props.issueStats
  );
  if (data.topIssueTitles.length <= 2) {
    return null;
  }

  return (
    <Box spaceBottom="xlarge">
      <Header
        icon="issue"
        subtitle={
          <FormattedMessage
            defaultMessage="Most common issue descriptions over the last 30 days"
            description="Issue Stats Top Types subtitle"
          />
        }
      >
        <FormattedMessage
          defaultMessage="Most common Issues"
          description="Issue Stats Top Types title"
        />
      </Header>
      <Inline space="small">
        {data.topIssueTitles.slice(0, 5).map((t) => (
          <Box
            key={t.title}
            cornerRadius="medium"
            color="surface-primary"
            spaceVertical="small"
            spaceHorizontal="small"
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexShrink: 1,
            }}
          >
            <AHText
              spaceRight="small"
              type="subtitle"
              color="text-primary"
              style={{ flexShrink: 1 }}
            >
              {t.title ?? intl_tokens.Issue}
            </AHText>
            <Circle color="status-negative" size="smallMedium">
              <AHText type="subtitle" color="text-inverted">
                {t.count}
              </AHText>
            </Circle>
          </Box>
        ))}
      </Inline>
    </Box>
  );
}
